module.exports = __webpack_public_path__ + "img/cw.c2c720ba.svg";